import React, { useRef, useEffect } from 'react';
import './BakeryHero.css';

const BakeryHero = () => {
  const videoRef = useRef(null);

  // Lazy-load autoplay with IntersectionObserver
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && videoRef.current && videoRef.current.paused) {
          videoRef.current.play().catch(() => {}); // ignore autoplay errors
        }
      },
      { threshold: 0.5 }
    );
    if (videoRef.current) observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, []);

  const togglePlayback = () => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {}); // ignore autoplay restrictions
    } else {
      video.pause();
    }
  };
  //https://res.cloudinary.com/dqqoti4er/video/upload/v1746213373/pablitostacos_1706298867_3288994593927716818_9383903430_ji6wkz.mp4
  //https://res.cloudinary.com/dqqoti4er/video/upload/v1745950049/pablitostacos_1744041936_3605607345249761597_9383903430_hedr4l.mov
  return (
    <div className="hero-container">
      <video
        ref={videoRef}
        muted
        loop
        playsInline
        preload="none"
        className="hero-video"
        onClick={togglePlayback}
      >
        <source
          src="https://res.cloudinary.com/dqqoti4er/video/upload/v1753947978/jojos_intro_1_myplca.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      <div className="hero-text">
        {/* <h1>Jojos Mediterranean Grill</h1> */}
        {/* <p>The best, authentic Lebanese cuisine that Los Angeles has to offer.</p> */}
        <img style={{ maxWidth: "150px", width: "100%",  height: "auto" }} src="https://afag.imgix.net/jojos-mediterranean-grill/logo-2.png?w=300&auto=format" alt="Jojo's Mediterranean Grill" />
      </div>

      <button
        className="hero-toggle-button"
        onClick={togglePlayback}
        aria-label="Toggle video"
      >
        ❚❚
      </button>
    </div>
  );
};

export default BakeryHero;